<template>
  <div>
    <v-container v-if="pageLoading" grid-list-xl text-xs-center>
        <v-layout>
            <v-flex>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <v-alert
      :value="true"
      type="info"
      v-if="!availableDocuments && !pageLoading"
    >
        En este momento no hay firma de documentos activa.
    </v-alert>
    <div v-else-if="!pageLoading">
      <v-toolbar flat color="white">
        <v-toolbar-title>Firmar documentos - {{ pageTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid class="pa-0 pt-2">
        <v-layout row wrap >
          <v-flex
            v-for="(document, i) in documents"
            :key="`ds-${i}`"
            xs12 sm6 md6 lg6 xl4
          >
            <v-card 
              elevation-1
              class="question-card ma-2 text-md-left"
                >
                <v-card-text style="height:70px;">
                  <h3 class="title pb-2">{{ document.document }}</h3>
                  <small class="grey--text caption">{{ document.updated_at ? document.updated_at.substring(0,16) : '' }}</small>
                </v-card-text>
                <v-card-actions>
                  <v-btn      
                    v-if="document.several_signs == 0 || (document['360_document_status'] == 'F' || document['360_document_status'] == 'P')"
                    :color="getColor(document['360_document_status'])"
                    flat block
                    @click="handleSign(document)"
                  >
                    <v-icon left >{{ document['360_document_status'] == 'F' ? 'search' : document.several_signs == 1 ? 'file_copy' : 'file_copy' }}</v-icon>
                    
                    {{ document['360_document_status'] == 'F' ? 'Firmado' : document.several_signs == 1 ? 'Firmar' : 'Pendiente por Firmar' }}
                  </v-btn>
                  <v-btn  
                    v-if="(i == 0 && document.several_signs == 1) || (i > 0 && document.several_signs == 1 && documents[i].document_id !== documents[i-1].document_id) "             
                    :color="getColor('')"
                    @click="handleSign(document, true)"
                    flat block
                  >
                    <v-icon left >file_copy</v-icon>
                    Firmar nuevo
                  </v-btn>
                </v-card-actions>    
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-dialog
      v-model="dialogDigitalSign"
      fullscreen>
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="rowid_tercero"
        :documentId="documentSignId"
        :action="vista_action"
        :processId="document_process_id"
        :recordId="vista_record_id"
      ></digital-sign-comp>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'documents-employee-view',
    components: {
      'digital-sign-comp': DigitalSignComponent,
    },
    data() {
      return {
        documents: [],
        pageLoading: true,
        dialogDigitalSign: false,
        documentSignId: 0,
        document_process_id: 0,
        vista_action: '',
        vista_record_id: '',
        rowid_tercero: '',
      }
    },
    computed: {
      pageTitle() {
        let title = ''
        if (this.documents.length > 0) {
          title = this.documents[0].sign_desc
        }
        return title
      },
      availableDocuments() {
        return this.documents.length > 0
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('api/employe/available/documents')
          .then(resp => {
            if (resp.status === 200) {
              this.documents = resp.data.documents
              this.pageLoading = false
            }
          })
          .then(err => {
            this.pageLoading = false
          })
      },
      getColor(number) {
        let color = ''
        switch (number) {
          case 0:
            color = 'primary'
            break;
          case 'P':
            color = 'accent'
            break;
          case 'F':
            color = 'success'
            break;

          default:
            color= 'primary'
            break;
        }
        return color
      },
      async handleSign(document, isNew = false) {
        let newIdProcess = 0
        if (isNew) {
          const payload = {
            sign_date_id: document.sign_date_id,
            document_id: document.document_id,
            rowid_tercero: document.rowid_tercero,
          }
          const { data } = await axios.post('/api/documents/serveral_signs/employee/add_new', payload)
          newIdProcess = data.id
        }
        if(!isNew){
          if (document[`360_document_status`] == 'F') {
            this.vista_action = 'SHOW'
            this.vista_record_id = document['360_document_id'];
            this.dialogDigitalSign = true
            return
          }

          if (document[`360_document_status`] == 'P') {
            this.vista_action = 'UPDATE'
            this.document_process_id = document.id
            this.documentSignId = document.vista_id
            this.vista_record_id = document['360_document_id']
            this.dialogDigitalSign = true
            this.rowid_tercero = document.rowid_tercero
            return
          }
        }
        console.log(isNew, newIdProcess, document.id)
        this.vista_action = 'CREATE'
        this.document_process_id = isNew ? newIdProcess : document.id
        this.documentSignId = document.vista_id
        this.rowid_tercero = document.rowid_tercero
        this.dialogDigitalSign = true
      },
      closeSignDialog() {
        this.dialogDigitalSign = false
        this.documentSignId = 0
        this.document_process_id = 0
        this.vista_action = ''
        this.vista_record_id = ''
        this.rowid_tercero = ''
        this.init()
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/employee_sign.vue